export const inputs = [
  {
    address: "bc1pgfvkcyfg2hnn...1wrfy5",
    amount: "0.00000330",
    symbol: "BTC",
    formattedFiat: "$0.31",
  },
  {
    address: "bc1qsyfyv68nmsx4...av4sm4",
    amount: "0.00001000",
    symbol: "BTC",
    formattedFiat: "$0.94",
  },
];

export const outputs = [
  {
    address: "bc1q4fdk9m2fxx4...c3z45q",
    amount: "0.00000330",
    symbol: "BTC",
    formattedFiat: "$0.31",
  },
  {
    address: "bc1qsyfyv68nmsx4...av4sm4",
    amount: "0.00000280",
    symbol: "BTC",
    formattedFiat: "$0.26",
  },
  {
    address: "bc1pgfvkcyfg2hnn...1wrfy5",
    amount: "0.00000100",
    symbol: "BTC",
    formattedFiat: "$0.09",
  },
];
